import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import JsBridgeNew from "@/utils/jsbridgeNew";
import {objectToQueryParams} from "@/utils/publicFun";
import qs from "query-string";

/**
 * @description 茅台二期
 * @return {/culturalExchange_maotaisecond/home}
 */
const Btns = [
  { title: '规则', key: 1 }, { title: '实名', key: 2 },
]

/** 首页「藏品回收」展示格：写死占位，不跟汇总接口联动 */
const RECYCLE_DISPLAY_SLOTS = [
  { key: 'recycle-slot-0', empty: false, image: require('@/assets/img/culturalExchange_integral/1.png'), points: 2000 },
  { key: 'recycle-slot-1', empty: false, image: require('@/assets/img/culturalExchange_integral/2.png'), points: 4000 },
  { key: 'recycle-slot-2', empty: false, image: require('@/assets/img/culturalExchange_integral/3.png'), points: 6000 },
  { key: 'recycle-slot-3', empty: false, image: require('@/assets/img/culturalExchange_integral/4.png'), points: 10000 },
]

const Home = () => {
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [data, setData] = useState({});
  const [hasPermission, setHasPermission] = useState(false)
  // const [shiwuThing, setShiwuThing] = useState({})
  const { nftNo } = qs.parse(window.location.search);
  const [canRecycle, setCanRecycle] = useState(true) // 是否可跳转回收（汇总列表为空则置灰）

  useEffect(() => {
    (()=>{
      getData(true);
      onDidFocus();
      // getData2()
      // setShowClaimSuccessModal(true);
    })()

  }, []);
//   const getData2 = async () => {
//     try {
//         showLoading()
//         const res = await Service.getGoodsDetail({collectionId: Service.collectionId})
//         hideLoading();
//         if (res.code !== '000000') throw res.msg;
//         if (res.data && res.data.info) {
//             setDetailData(res.data.info)
//         }
//     } catch (error) {
//         Toast.show(error);
//     }
  
// }

  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus();
    });
  }
  const getData = async (loading = false) => {
    // const res2 = await Service.getGoodsData({},nftNo);
    try {
      if (loading) showLoading();
      if (loading) {
        const ruleres = await Service.getActivityRules();//解决没有token的问题
        const userInfoRes = await Service.getUserCertificateStatus();
        const accessRes = await Service.purchasePermissions();
        setUserInfo(userInfoRes);
        // setHasPermission(accessRes.data?.isPermission);
        // console.log(accessRes.data, accessRes.data.isPermission);
        // const res2 = await Service.getGoodsData({},nftNo);
        // if(res2?.data?.length > 0){
        //   const shiwu = res2.data.find(item => item?.goodsType === 3)
        //   console.log('shiwu===>', shiwu)
        //   setShiwuThing(shiwu)
        // }
      }
      const res = await Service.getInitData();
      if (loading) hideLoading();
      if (res.code !== '000000') throw res.msg;
      setData(res.data);
      // setHasPermission(res.data?.isPermission)

      // 判断是否存在可回收的藏品（汇总列表为空 => 按钮置灰且不可跳转）
      try {
        if (process.env.NODE_ENV === "development") {
          setCanRecycle(true);
        } else {
          const collRes = await Service.getRecoveryCollCount();
          const list = Array.isArray(collRes?.data) ? collRes.data : (collRes?.data?.list || []);
          setCanRecycle((list || []).length > 0);
        }
      } catch {
        // 接口异常时不强制禁用，避免误伤；后续跳转页会展示空态
        setCanRecycle(true);
      }
    } catch (error) {
      hideLoading();
      Toast.show(error);

    }
  }

  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }

  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }

    return msg;
  }, [data]);

  // 回收时间提示：点击按钮时实时计算，避免使用初始化时的时间
  const getRecoveryTipsMessage = () => {
    const { recoveryStartTime, recoveryEndTime } = data || {};
    if (!recoveryStartTime || !recoveryEndTime) {
      return "回收时间异常";
    }
    const nowT = Date.now();
    const startT = new Date(recoveryStartTime.replace(/-/g, "/")).getTime();
    const endT = new Date(recoveryEndTime.replace(/-/g, "/")).getTime();
    if (Number.isNaN(startT) || Number.isNaN(endT)) {
      return "回收时间异常";
    }
    if (nowT < startT) {
      return "回收暂未开始";
    }
    if (nowT > endT) {
      return "回收已结束";
    }
    return "";
  };

  const buyHandle = () => {
    // const bynum = pageType === 1 ? (data?.ordNum || 0) : pageType === 2?(data?.rareNum || 0):0;
    // if(bynum === 0){
    //   Toast.show("超过购买数量");
    //   return;
    // }
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if (!userInfo?.ID) {
      Toast.show("请先实名认证");
      return;
    }
    const uri = `/ape/saleDetail?collectionId=${Service.collectionId}&code=${Service.activityCode}`;
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", {
        uri: `${window.location.origin}${uri}`,
      });
    } else {
      navigate(uri);
    }
    
  }
  const onRightBtnClick = (item) => {
    if (item.key === 1) {
      const ModalInstance = NFTModal.show({
        content: <ActivityRules onClose={() => ModalInstance?.close()} />,
        getContainer: pageDom.current,
      });
    } else if (item.key === 2) {
      window.JsBridge.navigate('Verify');
    }
  }

  const handleRecycleNow = () => {
    const recoveryTipsMessage = getRecoveryTipsMessage();
    if (recoveryTipsMessage) {
      Toast.show(recoveryTipsMessage);
      return;
    }
    if (!canRecycle && process.env.NODE_ENV !== "development") {
      Toast.show("暂无可回收藏品");
      return;
    }
    const uri = `/culturalExchange_integral/recycleSelect`;
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push('CustomWeb', {
        uri: `${window.location.origin}${uri}`,
      })
    } else {
      navigate(uri)
    }
  }

  return (
    <div className={Styles.culturalExchangeHome} ref={pageDom}>
       <div className={Styles.topCard}>

      </div>
      <div className={Styles.back} onClick={onBack}></div>
      <div className={Styles.right_btns}>
        {
          Btns.map((btn, i) => {
            if (btn.key === 2 && userInfo?.ID) return null;
            return (
              <div key={i} className={Styles.rightBtn} onClick={() => onRightBtnClick(btn)}>{btn.title}</div>
            )
          })
        }
      </div>
      <div className={Styles.buyBtn} onClick={buyHandle}>
        {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
      </div>
      {/* <button className={Styles.myCollectionsBtn} onClick={toMyGuards}>我的藏品{">"}</button> */}
      {/* {data?.allowNum && <div className={Styles.textCount}>最多可购买{data?.allowNum || 0}个</div>} */}
      {/* <div className={Styles.textCount}>剩余可购买数量：{pageType === 1 ? (data?.ordNum || 0) : pageType === 2?(data?.rareNum || 0):0}</div> */}
      <div className={Styles.centerCard}>
        <div className={Styles.collectionRecycle}>
          <div className={Styles.collectionRecycleTitle}>藏品回收</div>
          <div className={Styles.collectionRecycleGrid}>
            {RECYCLE_DISPLAY_SLOTS.map((slot) => {
              const hasPoints =
                !slot.empty &&
                slot.points != null &&
                !Number.isNaN(slot.points)
              const badgeMuted = slot.empty || !hasPoints
              return (
                <div key={slot.key} className={Styles.collectionRecycleCell}>
                  <div className={Styles.collectionRecycleThumb}>
                    {!slot.empty && slot.image ? (
                      <img src={slot.image} alt="" className={Styles.collectionRecycleThumbImg} />
                    ) : null}
                  </div>
                  <div
                    className={
                      badgeMuted
                        ? Styles.collectionRecycleBadgeMuted
                        : Styles.collectionRecycleBadge
                    }
                  >
                    <span className={Styles.collectionRecyclePointsNum}>
                      {hasPoints ? slot.points : '—'}
                    </span>
                    <span className={Styles.collectionRecyclePointsUnit}>积分</span>
                  </div>
                </div>
              )
            })}
          </div>
          <button
            type="button"
            className={Styles.collectionRecycleBtn}
            onClick={handleRecycleNow}
            disabled={!canRecycle && process.env.NODE_ENV !== "development"}
            aria-label="立即回收"
          />
        </div>
      </div>

      <div className={Styles.footerBox}>
        <div className={Styles.footer} />
      </div>

    </div>
  )
}
export default Home
